import { GenericModal } from '@/components/shared/GenericModal';
import { useAtom } from 'jotai';
import { isBulkReferenceDrawingsOpen } from '@/components/Analysis/state/atoms';
import { Box, Stack, Typography } from '@mui/material';
import {
  WizardStepper,
  WizardStep,
} from '@/components/EsSheet/EquipmentStrategyOnboarding/shared/WizardStepper';
import { WizardProvider, useWizard } from './context/WizardContext';
import { SelectFiles } from './SelectFiles/SelectFiles';
import { MapAssemblies } from './MapAssemblies/MapAssemblies';
import { Review } from './Review/Review';
import { AbyssIcon } from '../../../../../assets/icons/AbyssIcon';

const WIZARD_STEPS_DETAILS = [
  { name: 'Select Files', iconName: 'import-alt' },
  { name: 'Map Assemblies', iconName: 'layout-row-line' },
  { name: 'Review & Upload', iconName: 'chat-check-line' },
];

const WIZARD_STEPS: WizardStep[] = [
  { label: 'Select Files' },
  { label: 'Map Assemblies' },
  { label: 'Review & Upload' },
];

const WizardContent = () => {
  const { activeStep } = useWizard();
  const steps = WIZARD_STEPS_DETAILS.map((step) => ({
    label: step.name,
    icon: <AbyssIcon iconName={step.iconName ?? ''} size="md+" />,
    activeIcon: <AbyssIcon iconName={(step.iconName ?? '') + '-active'} size="md+" />,
    completedIcon: <AbyssIcon iconName="checkbox-circle-fill" size="md+" />,
  }));

  return (
    <Stack gap="6.4rem" height="100%" alignItems="center">
      <Stack width="90rem">
        <WizardStepper steps={steps} activeStep={activeStep} useIcons />
      </Stack>
      <Box flex={1} display="flex" flexDirection="column" overflow="hidden">
        {activeStep === 0 && <SelectFiles />}
        {activeStep === 1 && <MapAssemblies />}
        {activeStep === 2 && <Review />}
      </Box>
    </Stack>
  );
};

export const ReferenceDrawingsUpload = () => {
  const [isOpen, setIsOpen] = useAtom(isBulkReferenceDrawingsOpen);

  return (
    <GenericModal
      open={isOpen}
      handleClose={() => setIsOpen(false)}
      title="Bulk Reference Drawings Upload"
      titleSx={{
        typography: 'h4',
      }}
      backgroundPaperStyle={{
        width: '140rem',
        height: '80vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '0.8rem',
      }}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Stack
        padding="3.2rem"
        paddingTop={0}
        flex={1}
        overflow="hidden"
        display="flex"
        flexDirection="column"
      >
        <Typography variant="body2" color="primary.400" marginBottom="6.4rem">
          Upload multiple reference drawing PDFs and map them to assemblies in one go.
        </Typography>
        <Stack>
          <WizardProvider>
            <WizardContent />
          </WizardProvider>
        </Stack>
      </Stack>
    </GenericModal>
  );
};
